import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';
import PlanComponent from '../components/plan.component';
import * as R from 'ramda';
import { toast } from 'react-toastify';
import { selectPlansCreatedItem, selectPlansQueryItems } from '../../../../../../redux/plans/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectTagNamesListItems } from '../../../../../../redux/tag-names/selector';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { plans } from '../../../../../../redux/plans/action';
import PageLoader from '../../../../../../components/PageLoader';
import { formatTagListData } from '../../../../../../common/services/common.service';
import { tagNames } from '../../../../../../redux/tag-names/action';


export const PLAN_ENTITY_VALUE = 100
export const EMAIL_PLAN_ENTITY_VALUE = 101
export const SMS_PLAN_ENTITY_VALUE = 102
export const WHATSAPP_PLAN_ENTITY_VALUE = 103
export const BUDGET_ENTITY_VALUE = 104
export const TEMPLATE_ENTITY_VALUE = 105


export default function PlanContainer ({ id }: any)  {  
  const planCreateItems  = useSelector(selectPlansCreatedItem)
  const planQueryItems = useSelector(selectPlansQueryItems)
  const libraryData = useSelector(selectListItems)
  const [planData, setPlanData] = useState<boolean>(false)
    const customerTags = useSelector(selectTagNamesListItems)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [choosenPlan, setChoosenPlan] = useState<any>({
    Id: 0,
    Name: '',
    CampaignFrequencyId: '',
    StartDate: '',
    EndDate: '',
    IsEmailCampaignIncluded: true,
    IsSMSCampaignIncluded: true,
    IsWhatsappCampaignIncluded: true,
    IsFacebookCampaignIncluded: false,
    IsWebCampaignIncluded: false
  })
  const [planBudget, setPlanBudget] = useState<any>([])
  const [planNotes, setPlanNotes] = useState<any>([])
  const [choosenSmsPlan, setChoosenSmsPlan] = useState<any>({
    Id: 0,
    Name: '',
    FrequencyId: 0,
    RecipientTagIdInclusions: [],
    StartDate: '',
    EndDate: ''
  })
  const [smsBudget, setSmsBudget] = useState<any>([])
  const [smsNotes, setSmsNotes] = useState<any>([])
  const [choosenEmailPlan, setChoosenEmailPlan] = useState<any>({
    Id: 0,
    Name: '',
    FrequencyId: 0,
    RecipientTagIdInclusions: [],
    StartDate: '',
    EndDate: ''
  })
  const [emailBudget, setEmailBudget] = useState<any>([])
  const [emailNotes, setEmailNotes] = useState<any>([])
  const [choosenWhatsappPlan, setChoosenWhatsappPlan] = useState<any>({
    Id: 0,
    Name: '',
    FrequencyId: 0,
    RecipientTagIdInclusions: [],
    StartDate: '',
    EndDate: ''
  }
)
  const [whatsappBudget, setWhatsappBudget] = useState<any>([])
  const [whatsappNotes, setWhatsappNotes] = useState<any>([])

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setChoosenPlan({ ...choosenPlan, [fields[0]]: value });
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setChoosenPlan({ ...choosenPlan, [field]: event })
  }

  const handleInnerEmailFormChange: any = (event: any, field: string) => {
    setChoosenEmailPlan({ ...choosenEmailPlan, [field]: event })
  }

  const back = () => {
    navigate(-1)
  }

  const handleSubmit = () => {
    if (choosenPlan?.Id === 0){
      createMarketingPlan();
    } else {
      updateMarketingPlan();
    }    
  }

  //#region API Calls
  const fetchTagEntitys = async () => {
    dispatch(tagNames.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
      entity: 'tagNames',
      jsonData: {
        Records: [
          {
            EntityType: 17
          } 
        ]
      }
  }))
  }

  const lsitMarketingPlans = () => {
    dispatch(plans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/list`,
      entity: 'plans',
      jsonData: {        
      }
    }))
  }

  const queryMarketingPlan = (id: Number) => {
    dispatch(plans.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/query`,
      entity: 'plans',
      jsonData: {
        "Records": [
          {
            "Id": id
          }
        ]
      }
    }))
  }

  const createMarketingPlan = async () => {
    await dispatch(plans.resetAction({ actionType: 'create' }))
    await dispatch(plans.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans`,
      entity: 'plans',
      jsonData: {
        "Records": [
          choosenPlan
        ]
      }
    }))
    toast.success("Plan created successfully")
    setChoosenPlan({})
    navigate('/agencies/promotions/marketing/plan')
  }

  const updateMarketingPlan = async () => {
    await dispatch(plans.resetAction({ actionType: 'update' }))
    await dispatch(plans.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans`,
      entity: 'plans',
      jsonData: {
        "Records": [
          choosenPlan
        ]
      }
    }))
    navigate('/agencies/promotions/marketing/plan')
  }
  //#endregion

  //#region UseEffect
 
  useEffect(() => {
    fetchTagEntitys()
    if (parmas?.id > 0) {
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }
  },[])

  useEffect(() => {
    if(parmas.id >0 ){
      queryMarketingPlan(Number(parmas.id))
    }
  }, [parmas.id]);

  useEffect(() => {
    if((planQueryItems?.result?.items && parmas.id>0)){
      setChoosenPlan(planQueryItems?.result?.items)
    }
    
  }, [planQueryItems]);

  //#endregion

  return (
    <>
    {isLoading ? <PageLoader /> :
      <PlanComponent
        customerTags={formatTagListData(customerTags?.result?.items)}
        choosenPlan={choosenPlan}
        campaignFrequency={libraryData?.result?.CampaignFrequency}
        planBudget={planBudget}
        planNotes={planNotes}
        choosenSmsPlan={choosenSmsPlan}
        smsBudget={smsBudget}
        smsNotes={smsNotes}
        choosenEmailPlan={choosenEmailPlan}
        emailBudget={emailBudget}
        emailNotes={emailNotes}
        choosenWhatsappPlan={choosenWhatsappPlan}
        whatsappBudget={whatsappBudget}
        whatsappNotes={whatsappNotes}
        handleSubmit={handleSubmit}
        back={back}
        handleInnerFormChange ={handleInnerbasicFormChange }
        handleInnerEmailFormChange={handleInnerEmailFormChange}

        id={parmas?.id}
      />
    }
    </>
  )
}


